import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'ramda'
import withStyle, {
  StyledSuccessIcon,
  StyledMessage,
  StyledCloseIcon,
  IE11FlexWrapper,
} from './Toast.style.js'

const iconType = {
  success: 'check-circle',
  info: 'info-circle',
  warning: 'exclamation-circle',
  error: 'exclamation-circle',
}

const Toast = ({ className, type, closable, message, onClose }) => (
  <div className={className}>
    <IE11FlexWrapper>
      <StyledSuccessIcon
        type={type}
        icon={iconType[type]}
        fill="filled"
        hoverTheme="filled"
      />
      <StyledMessage>{message}</StyledMessage>
      {closable && <StyledCloseIcon onClick={onClose} icon="close" />}
    </IE11FlexWrapper>
  </div>
)

Toast.defaultProps = {
  className: 'chec-toast',
  closable: false,
  onClose: () => {},
}

Toast.propTypes = {
  className: PropTypes.string,
  /** manually close the toast */
  closable: PropTypes.bool,
  /** Toast Type  */
  type: PropTypes.oneOf(['success', 'info', 'warning', 'error']).isRequired,
  /** Toast Message */
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  /** Function to call when manually closing toast */
  onClose: PropTypes.func,
}

export default compose(withStyle)(Toast)
